<template>

<div ref="whole_page">
  <vx-card id="upload-card" class="overflow-hidden contentCards" style="width: 100%; padding:10px">
    <h2 class="mb-4 text-left" style="color: white !important"> {{ upload.name }}</h2>
      <div class="text-left" v-html="upload.description"></div>
    <div class="w-full mt-6 text-left" v-if="upload.id && upload.documents.length > 0">
      <h6 class="mb-4">Additional Resources</h6>
      <div v-for="(_document, index) in upload.documents" :key="index">
        <div class="vx-col w-1/3 mx-left">
          <div style="display: flex; align-items: left;">
            <div style="border-right-style: solid; border-right-width: 1px; border-right-color: #cacaca;">
              <vs-button class="mr-2" color="success" type="filled" size="small" icon-pack="feather" icon="icon-download" @click="downloadPinnedDoc(_document.url)"></vs-button>
            </div>
            <div class="ml-2">
              <p><strong>{{ _document.url.substring(_document.url.indexOf('_') + 1) }}</strong></p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <vs-divider></vs-divider>

      <div class="centersubmitbutton">
        <vx-card card-background="#262d4a" class="glow-effect_dark limit-width_uploader" style="width: 89vw; min-width: unset !important">
          <vx-input-group>
            <template slot="prepend">
              <div class="prepend-text input-group_prepend-slot-bg">
                <span><feather-icon class="pt-1" icon="UploadCloudIcon" svg-classes="stroke-current"></feather-icon></span>
              </div>
            </template>
              <file-pond
                v-show="true"
                id="cover-filepond"
                ref="newUploadPond"
                :server="uploadLocation"
                label-idle="<span style='color:white'>Upload here</span>"
                :allow-multiple="upload.allowMultiple"
                :allow-image-preview="false"
                :accepted-file-types="types"
                :instant-upload="true"
                allowPaste=false
                @processfile="uploadComplete"
                @removefile="fileRemoved"
                />
          </vx-input-group>
        </vx-card>
      </div>

      <div v-show="timeCapture.captureTimeForAssessments && $siteTypeId() != 1" class="hoursUsed mb-8 mt-4">
        <p class="mb-2"> How many hours did you spend preparing for the assessment? </p>
        <vue-slider
          class="w-full mb-5 slider-width-learningstyleb"
          :tooltip="'none'"
          v-model="timeCaptureOnUploadTask"
          :adsorb="true"
          :min="taskClassificationTypeId == 1 ? timeCapture.sliderMinFormatives : timeCapture.sliderMinSummatives"
          :max="taskClassificationTypeId == 1 ? timeCapture.sliderMaxFormatives : timeCapture.sliderMaxSummatives"
          :data-label="'id'"
          :data-value="'id'"
          :marks="true"
        ></vue-slider>
      </div>
      
      <div class="centersubmitbutton">
        <div v-if="!moduleId" id="submitButton">
          <vs-button v-if="showSubmitButton" class="mr-4 mt-4 vs-con-loading__container cursor-pointer text-left" color="success" @click="saveData" ref="addupdateButton">Submit</vs-button>   
        </div>
      </div>
      
      <!-- <div class="centersubmitbutton">
        <vx-card v-if="$siteTypeId() !=  1 && moduleId" ref="chat_card" class="mb-4 mt-2 vs-con-loading__container button-center-bottom" @click="saveData" style="border-radius: 20px !important; padding:9px !important;height: 65px !important;">
          <div class="vx-row">
            <div class="vx-col w-full">
              <div class="vx-row">
                <div class="vx-col self-center">
                  <svg xmlns="http://www.w3.org/2000/svg" style="color: white" width="35" height="35" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-check-circle"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path><polyline points="22 4 12 14.01 9 11.01"></polyline></svg>
                </div>
                <div style="width: 70% !important;text-align:left !important">
                  <p class="uppercase" style="color: white;font-size:16px">COMPLETED <br>NOW PROCEED</p>
                </div>
              </div>
            </div>
          </div>
        </vx-card>
      </div> -->

      <div class="completebuttonstylebupload">
        <div class="flex next_btns__container justify-center">
          <vs-button v-show="$acl.check('Student') && styleB" id="completetask-btn" class="vs-con-loading__container next_btns clickbuttonactive" 
          ref="submit_btn" icon-pack="feather" icon="icon-arrow-right" icon-after
          @click="saveData">
          Complete
          </vs-button>
        </div>
      </div>

      <div class="completebuttonstylebupload">
        <div class="flex next_btns__container justify-center">
          <vs-button v-show="!$acl.check('Student') && styleB" id="completetask-btn" class="vs-con-loading__container next_btns clickbuttonactive" 
          ref="submit_btn" icon-pack="feather" icon="icon-arrow-right" icon-after
          @click="saveData">
          Complete
          </vs-button>
        </div>
      </div>
      
        
        <div v-show="!onlyContent" class="fab_direction-up__three-items">
          <div class="fab_direction-up__three-items">
            <div class="float-btn-group">
              <button class="btn-float btn-triger school-primary_gradient glow-effect_primary" @click="openActions">
                <i class="icon feather icon-more-horizontal text-white" />
              </button>
              <div class="btn-list">
                <a class="btn-float dc_dark-purple description glow-effect_dark" @click="backToTopic">
                  <span class="descriptiontext">{{ topicName }}</span>
                  <i class="icon feather icon-arrow-up text-white"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
    </vx-card>

    <vs-popup 
      title="Cannot Continue"
      id="formative-assessments-marked-popup" 
      :active.sync="isTaskBlocked">
      <p class="pb-2">Well done on completing your Formative Assessments! Your answers will be assessed by a registered Assessor. You will receive a notification regarding the outcome.</p>
      <div class="mt-3">
        <vs-button color="success" class="float-right" @click="isTaskBlocked = false">Go to Dashboard</vs-button>
      </div>
    </vs-popup>
</div>
</template>

<script>
import vueFilePond from 'vue-filepond';
import vSelect from 'vue-select'

import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
import FilePondPluginImagePreview from 'filepond-plugin-image-preview';
import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/antd.css'

const FilePond = vueFilePond(FilePondPluginFileValidateType, FilePondPluginImagePreview);

export default {
  components: {
    FilePond,
    vSelect,
    VueSlider,
  },
  computed: {
    uploadLocation: {
      get() {
        return this.$buildUrl("tempupload");
      }
    },
    showSubmitButton(){
      var self = this;
      if(self.$route.query.redo && self.startLogComplete){
        return true;
      }
      else if (self.$route.query.redo && !self.startLogComplete){
        return false;
      }
      else{
        return true;
      }
    }
  },
  data() {
    return {
      queue: [],
      uuid: "",
      logData: {},
      fabElement: null,
      upload: {},
      documentUrl: "",
      onlyContent : false,
      backgroundCardHeight: 0,
      backgroundCardWidth: 0,
      standaloneContentDto: {},
      selectedData: {},
      topicName: '',
      index: null,
      currentTask: null,
      nextTask: null,
      prevTask: null,
      navigateByChoice: false,
      isTeacher: false,
      UploadFile: [],
      types: [],
      moduleId: 0,
      taskId: 0,
      styleB: false,
      isTaskBlocked: false,
      taskClassificationTypeId: 0,
      timeCapture:{
        captureTimeForAssessments: false,
        formativeHoursRequired: null,
        summativeHoursRequired: null,
        sliderMinFormatives: 0,
        sliderMaxFormatives: 0,
        sliderMinSummatives: 0,
        sliderMaxSummatives: 0
      },
      timeCaptureOnUploadTask: 0,
      startLogComplete:false,
      redoUUID:"",
    };
  },
  watch:{
    isTaskBlocked: function(){
      var self = this;
      if(!self.isTaskBlocked)
      {
        self.backToDashboard();
      }
    },
  },
  methods: {
    backToTopic() {
      var self = this;
      self.navigateByChoice = false;
      if (self.$route.query.outcome) {
        self.$router.push({ name: self.$route.name == 'PublicUploadViewer' ? "PublicOutcomeTasks" : "Gen2OutcomeTasks", query: { moduleId: self.moduleId, lpName: self.$route.query.lpName, lpNumber: self.$route.query.lpNumber, selectedTaskGroup: self.$route.query.selectedTaskGroup, selectedOutcome: self.$route.query.selectedOutcome, timeCapture: JSON.stringify(self.timeCapture) }});
      } else {
        if(self.selectedData.selectedTopic)
          self.$router.push({ name: 'BrowseContent', params: { selectedData: self.selectedData, navFromVideo: true } });
        else if(self.selectedData.selectedTopic && self.isTeacher)
          self.$router.push({ name: 'TeacherBrowseContent', params: { selectedData: self.selectedData, navFromVideo: true } });
        else if(self.moduleId)
          self.$router.push({ name: 'LearningStyleBViewer', params: { moduleId: self.moduleId }});
        else if(self.$route.query.redo)
       	  window.open("", "_self").close();
        else
          self.$router.push({ name: 'StudentRoster' });
      }
    },
    openActions(e) {
      this.fabElement = e.target.closest(".float-btn-group");
      if (this.fabElement) {
        this.fabElement.classList.toggle('open')
      }
    },
    enqueue(messageType, logPayload) {
      this.queue.push({
        type: messageType,
        payload: {
          logIdentifier: logPayload.logIdentifier.toString(),
          toTaskId: logPayload.toTaskId,
          fromTaskId: logPayload.fromTaskId,
          taskId: logPayload.taskId,
          uploadedFiles: logPayload.uploadedFiles,
        }
      })
    },
    dequeue() {
      return this.queue.shift();
    },
    startProcessor() {
      var self = this;
      var onSuccess = function (response) {
        var next = self.dequeue();
        if (next)
          self.process(next, onSuccess);
      };
      setInterval(function () {
        if (self.queue.length > 0) {
          self.process(self.dequeue(), onSuccess)
        }
      }, 3000)
    },
    process(queueItem, successFunc) {
      var self = this;
      if (queueItem) {
        self.$ajaxPost(self, queueItem.type, queueItem.payload, function(response){
          successFunc();
        });
      }
    },
    downloadPinnedDoc(documentUrl) {
      window.open(documentUrl);
    },
    uploadComplete(error, file) {
      var self = this;

      var response = JSON.parse(file.serverId);
      if(response.url){

        self.UploadFile.push(response.url);

        self.$vs.notify({
          title:'Information',
          color: "success",
          text: "New File Saved",
          position:'top-right',
          iconPack: 'feather',
          icon:'icon-upload',
        });
      }        
    },
    fileRemoved(error, file) {
      var self = this;

      self.UploadFile = [];

      self.$vs.notify({
        title:'Information',
        color: "warning",
        text: "File Removed",
        position:'top-right',
        iconPack: 'feather',
        icon:'icon-upload',
      });
    },
    saveData(){
      var self = this;

      if (self.$acl.not.check('Student') && self.styleB) {
        self.$router.push({ name: 'LearningStyleBViewer', params: { moduleId: self.moduleId }});
      }

      if(!self.isTeacher){
        if(self.UploadFile.length > 0){
          self.showLoadingOnElement('whole_page', 1, 'material');
          if(!self.navigateByChoice) {
            self.logData.logIdentifier = self.redoUUID.length != 0 ? self.redoUUID  : self.uuid;

            if(self.currentTask){
              self.logData.fromTaskId = self.currentTask.id;
              self.logData.taskId = self.currentTask.id;
            }
            else{
              self.logData.fromTaskId = self.taskId;
              self.logData.taskId = self.taskId;
            }
            
            self.logData.toTaskId = null;
            self.logData.uploadedFiles = self.UploadFile;

            self.logData.timeCapture = self.timeCapture.captureTimeForAssessments 
                ? (self.timeCaptureOnUploadTask == null 
                  ? (self.taskClassificationTypeId == 1 
                    ? self.timeCapture.sliderMinFormatives : self.timeCapture.sliderMinSummatives) : self.timeCaptureOnUploadTask) : null;


            var onSuccess = function () {
              self.stopLoadingOnElement('whole_page');
              
                self.$vs.notify({
                title:'Information',
                color: "success",
                text: "File Submitted",
                position:'top-right',
                iconPack: 'feather',
                icon:'icon-upload',
              }); 

              self.backToTopic();
            };

            self.$ajaxPost(self, "UploadTask/EndLogEntry", self.logData, onSuccess);
          }
        }
        else{
          self.$vs.notify({
            title:'Information',
            color: "warning",
            text: "No File Uploaded",
            position:'top-right',
            iconPack: 'feather',
            icon:'icon-upload',
          }); 
        }
      }
      else{
        self.$vs.notify({
          title:'Information',
          color: "warning",
          text: "Only students will be able to submit",
          position:'top-right',
          iconPack: 'feather',
          icon:'icon-upload',
        }); 
      }
    },
    getTypes(){
      var self = this;

      if(self.upload){
        if (self.upload.allowAudio)
          self.types.push("audio/mp3");
        if (self.upload.allowDocument)
          self.types.push("application/pdf","application/msword", "application/vnd.ms-excel", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", "application/vnd.openxmlformats-officedocument.wordprocessingml.document", "text/plain","text/html", "application/msaccess","application/vnd.ms-powerpoint","application/vnd.openxmlformats-officedocument.presentationml.presentation");
        if (self.upload.allowImage)
          self.types.push("image/png", "image/jpg", "image/jpeg", "image/gif");
        if (self.upload.allowVideo)
          self.types.push("video/mp4", "video/mov", "video/wmv","video/quicktime");
      }

      self.types = self.types;
    },
    stopLoadingOnElement(element) {
      var self = this;
      self.$vs.loading.close(self.$refs[element].$el);
    },
    showLoadingOnElement(element, scale, type) {
      var self = this;
      self.$vs.loading({
        type: type,
        container: self.$refs[element].$el,
        scale: scale
      });
    },
    stopLoadingOnElement(element) {
      var self = this;
      self.$vs.loading.close(self.$refs[element].$el);
    },
    showLoadingOnElement(element, scale, type) {
      var self = this;
      self.$vs.loading({
        type: type,
        container: self.$refs[element].$el,
        scale: scale
      });
    },
    getIsTaskBlocked(){
      var self = this;

      self.taskClassificationTypeId = self.$route.query.taskClassificationTypeId;

      if(self.$route.query.taskClassificationTypeId == 2 && self.$acl.check("Student")){
        var studentId = localStorage.getItem("Current_User_Id");
        var onSuccess = function(response){
          self.isTaskBlocked = response.data == 2 ||  response.data == 1 ? true : false;
        } 
        self.moduleId = self.$route.query.moduleId;
        self.$ajaxGet(self, "StudentModule/GetStudentModuleStatusId?studentId=" + studentId + "&moduleId=" + self.moduleId, onSuccess)
      }
    },
    backToDashboard(){
      setTimeout(() => {
        this.$router.push({ name: "LearningStyleBViewer", params: { moduleId: this.moduleId}});
      }, 69);
    },
    startlogMethod(){
      var self = this;
      self.redoUUID = self.$uuid.v4();
      self.standaloneContentDto;
      self.logData.taskId = self.standaloneContentDto.id;

      self.logData.logIdentifier = self.redoUUID;
      self.logData.toTaskId = null;
      self.logData.fromTaskId = self.$route.params.fromTaskId ? self.$route.params.fromTaskId : null;
      self.logData.uploadedFiles = [];

      var onSuccess = response =>{
        setTimeout(function(){ self.startLogComplete = true; }, 300);
        
      };

      self.$ajaxPost(self,"UploadTask/StartLogEntry",self.logData,onSuccess);
    },
    getUploadTaskDataForRetry(){
      var self = this;

      var onSuccess = response =>{
        self.standaloneContentDto = response.data;
        self.startlogMethod();
      }

      self.$ajaxGet(self, "UploadTask/GetUploadByTaskId/" + self.$route.query.id , onSuccess);
    },

  },
  mounted() {
    var self = this;

    self.$store.dispatch("updateTheme", "dark");

    if(self.$route.query.styleB){
      self.getIsTaskBlocked();
    }else{
      self.isTaskBlocked = false;
    }
    
    if(!self.isTaskBlocked){
      self.startProcessor();

      self.isTeacher = localStorage.getItem("isTeacher");
      self.isTeacher = self.isTeacher == "true" ? true : false;

      var isStudentLocal = localStorage.getItem("isStudent");
      isStudentLocal = isStudentLocal == "true" ? true : false;

      if (Object.keys(self.$route.query).length != 0 && Object.keys(this.$route.params).length == 0) {
        if(self.$route.query.id){

          self.showLoadingOnElement('whole_page', 1, 'material');
          
          if(self.$route.query.styleB){
            self.timeCapture = JSON.parse(self.$route.query.timeCapture);
          }
          
          if(!localStorage.getItem("userInfo")) {
            document.cookie = "autoRedirect="+ JSON.stringify({url: self.$route.name, id: self.$route.query.id});
            window.location.replace("/login");
          }
            var success = (res) => {

              self.moduleId = self.$route.query.moduleId;
              self.taskId = self.$route.query.id;
              self.styleB = self.$route.query.styleB;

              localStorage.setItem("moduleId", self.moduleId);

              self.onlyContent = true;
              self.upload = res.data;

              if(res.data.documents.length != 0) 
                self.upload.url = res.data.documents[0].url;              

              self.uuid = self.$uuid.v4();
              
              self.logData.taskId = self.taskId;
              localStorage.setItem("tid", self.taskId);
              self.logData.logIdentifier = self.uuid;
              self.logData.toTaskId = null;
              self.logData.fromTaskId = self.$route.params.fromTaskId ? self.$route.params.fromTaskId : null;

              if(self.moduleId){
                self.enqueue("UploadTask/StartLogEntry", self.logData);
              }

              self.getTypes();

              self.stopLoadingOnElement('whole_page');
            };

          try{
            self.$ajaxGet(self, "UploadTask/GetUploadByTaskId/" + self.$route.query.id, success);
          } catch{} 
        }
      }
      else {
      if(Object.keys(this.$route.params).length != 0){
        self.index = self.$route.params.index;
        self.currentTask = self.$route.params.standaloneContent.tasks.filter(function(item) { return item.index == self.index })[0];

        self.upload = self.$route.params.standaloneContent.tasks.filter(function(item) { return item.index == self.index })[0].upload;

        self.getTypes();

        if(!self.upload.documents){
          self.upload.documents = [];
          self.upload.documents.push({
            url: self.upload.url,
          })
        }

        if (self.$route.params.standaloneContent.tasks.length > self.index + 1)
          self.nextTask = self.$route.params.standaloneContent.tasks.filter(function(item) { return item.index == (self.index + 1) })[0];

        if (self.index > 0)
          self.prevTask = self.$route.params.standaloneContent.tasks.filter(function(item) { return item.index == (self.index - 1) })[0];

        self.standaloneContentDto = self.$route.params.standaloneContent;
        if(self.$route.params.selectedData)
          self.selectedData = self.$route.params.selectedData;

        var data = {
          selectedData: self.selectedData,
          standaloneContentDto: self.standaloneContentDto,
          index: self.index
        }

        localStorage.setItem("lastKnownTopic", JSON.stringify(data));

        if(self.selectedData.selectedTopic)
          self.topicName = self.selectedData.selectedTopic.name;
        else
          self.topicName = "Back to My Roster";

        self.uuid = self.$uuid.v4();

        self.logData.fromTaskId = self.currentTask.id;
        self.logData.taskId = self.currentTask.id;
        localStorage.setItem("tid", self.currentTask.id);

        self.logData.logIdentifier = self.uuid;
        self.logData.toTaskId = null;
        self.logData.fromTaskId = self.$route.params.fromTaskId ? self.$route.params.fromTaskId : null;
        self.logData.uploadedFiles = [];

        self.enqueue("UploadTask/StartLogEntry", self.logData);
      }
        else {
          if (isStudentLocal) {
            self.$router.push({ name: 'StudentRoster' });
          }
          else {
            self.$router.push({ name: 'BrowseContent' });
          }
        }
      }
    }

    if(self.$route.query.redo){
      self.getUploadTaskDataForRetry();
    };

    
  }
};
</script>

<style lang="scss">

.next_btns__container {
  .next_btns {
    .vs-button--text {
      text-transform: uppercase !important;
    }

    .vs-icon {
      font-size: 1.2rem !important;
    }

    width: 100% !important;
  }

  #nexttask-btn {
    width: 13% !important;
    border-radius: 25px !important;
    background-image: linear-gradient(#1c80c4,  #2367a7) !important;
  }

  #completetask-btn {
    width: 225px !important;
    border-radius: 25px !important;
    background-image: linear-gradient(266deg, rgba(43,55,43,1) 0%, rgba(68,198,70,1) 78%) !important;
  }

  @media screen and (max-width: 900px) {
    #nexttask-btn {
      width: 45% !important;
    }

    #completetask-btn {
      width: 45% !important;
    }
  }

  @media screen and (max-width: 700px) {
    #nexttask-btn {
      width: 50% !important;
    }

    #completetask-btn {
      width: 50% !important;
    }
  }
}

  .contentCards {
    margin: auto;
  }

  .fab_direction-up__three-items {
    right: 5vw;
    bottom: 4vh;
    z-index: 999;
    position: fixed;
  }

  .filepond--panel-root {
  border-radius: 0 6px 6px 0;
  background-color: rgba(255, 255, 255, 0) !important;
  }

  .filepond--drop-label {
    color:rgb(202, 202, 202) !important;
  }

.button-center-bottom{
  position:relative !important;
  top:100% !important;
  width:260px !important;
  background: rgb(43,55,43) !important;
  background: linear-gradient(266deg, rgba(43,55,43,1) 0%, rgba(68,198,70,1) 78%) !important;
  &:hover{
    cursor: pointer;
  }
}

.vx-card__body{
  padding: 0px !important;
}
  .video-js{
    width:70% !important;
    height: 60vh;
  }
  @media only screen and (max-width: 600px){
    .plyr--video {
      text-align: -webkit-center;
      text-align: -moz-center;
      border-radius: 25px !important;
      min-height: 40vh !important;   
    }
    .video-js{
      height: 40vh !important;
      width: 95vw !important;
      border-radius: 28px !important;
    }
  }

.centersubmitbutton {
  position: relative !important;
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
}

.completebuttonstylebupload{
  padding: 2rem 0rem 10rem 0rem;
}

.filepond--wrapper {
  width: 100%;
}

.slider-width-learningstyleb{
  width: 96% !important;
}

</style>
